import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

//Components
import Layout from "./Layout";

//Actions
import { agriServiceMenu, agriServiceV2Menu, agriPVServiceMenu, cropMenu, dssMenu, meteoServiceMenu } from "../../service/MenuManager";

//Pages
import HomeContainer from "../Home/HomeContainer";
import DashboardContainer from "../Dashboard/DashboardDispatcher";
import AdministrationPage from "../Administration/AdministrationPage";
import DevicesManagerPage from "containers/Administration/DevicesManagerPage";
import DevicePage from "containers/Device/DevicePage";
import AlertLogPage from "containers/Alert/AlertLogPage";
import GuidePage from "containers/Guide/GuidePage";
import ProfileContainer from "../Profile/ProfileContainer";
import ServiceSelectionPage from "containers/ServiceSelection/ServiceSelectionPage";
import SettingsAgrismartDss from "containers/Settings/SettingsAgrismartDss";
import SettingsPage from "../Settings/SettingsPage";
import UsersContainer from "../Users/UsersContainer";
import AdversitiesPage from "containers/Agrismart/AdversitiesPage";
import AgrismartAlertLogPage from "containers/Agrismart/AgrismartAlertLogPage";
import AveragePage from "containers/Agrismart/AveragePage";
import AveragePageV2 from "containers/Agrismart/AveragePageV2";
import ConfigurationManager from "containers/Agrismart/ConfigurationManager";
import IntervalPageCmp from "containers/Data/IntervalPageCmp";
import IntervalPage from "containers/Data/IntervalPage";
import IntervalPageV2 from "containers/Data/IntervalPageV2";
import IntervalPageSolar from "containers/Data/IntervalPageSolar";
import IntervalPageTrapinst from "containers/Data/IntervalPageTrapinst";
import IntervalPageRadarpest from "containers/Data/IntervalPageRadarpest";
import PhenologyPage from "containers/Agrismart/PhenologyPage";
import SolarsmartAveragePage from "containers/Solarsmart/SolarsmartAveragePage";
import ReviewPage from "../Agrismart/ReviewPage";
import ReviewPageV2 from "containers/Agrismart/ReviewPageV2";
import BuildingAccessPage from "../Badge/BuildingAccessPage";
import CardAccessPage from "../Badge/CardAccessPage";
import SwitchData from "../Switch/SwitchData";
import Missing from "./Missing";


export default function Full() {

	let project = useSelector(store => store.session.project);
	let user = useSelector(store => store.users.data);

	return (
		<Routes>
			<Route path="/" element={<Layout />} >
				<Route index element={<HomeContainer project={project} user={user} />} />
				<Route path="dashboard" element={<DashboardContainer />} />

				<Route path="administration" element={<AdministrationPage />} />
				<Route path="agrialerts" element={<AgrismartAlertLogPage />} />
				<Route path="agriservice" element={<ServiceSelectionPage menu={agriServiceMenu() || []} />} />
				<Route path="agriserviceV2" element={<ServiceSelectionPage menu={agriServiceV2Menu() || []} />} />
				<Route path="agripvservice" element={<ServiceSelectionPage menu={agriPVServiceMenu() || []} />} />
				<Route path="alerts" element={<AlertLogPage />} />
				<Route path="buildingaccess">
					<Route index element={<Navigate to="/dashboard" />} />
					<Route path=":building" element={<BuildingAccessPage />} />
				</Route>
				<Route path="cardaccess">
					<Route index element={<Navigate to="/dashboard" />} />
					<Route path=":card" element={<CardAccessPage />} />
				</Route>
				<Route path="charts" element={<IntervalPage display={"charts"} type={'main'} />} />
				<Route path="charts-freezing" element={<IntervalPage display={"charts"} type={'freezing'} />} />
				<Route path="charts-irrigation" element={<IntervalPage display={"charts"} type={'irrigation'} />} />
				<Route path="charts-microclimate" element={<IntervalPageCmp display={"charts"} type={'microclimate'} />} />
				<Route path="charts-phytosanitary" element={<IntervalPage display={"charts"} type={'phytosanitary'} />} />
				<Route path="charts-solar" element={<IntervalPageSolar display={"charts"} type={'solar'} />} />
				<Route path="charts-trap" element={<IntervalPageRadarpest display={"charts"} type={'trap'} />} />
				<Route path="charts2" element={<IntervalPageV2 display={"charts"} type={'all'} />} />
				<Route path="charts2-freezing" element={<IntervalPageV2 display={"charts"} type={'freezing'} />} />
				<Route path="charts2-irrigation" element={<IntervalPageV2 display={"charts"} type={'irrigation'} />} />
				<Route path="charts2-phytosanitary" element={<IntervalPageV2 display={"charts"} type={'phytosanitary'} />} />
				<Route path="configuration-manager" element={<ConfigurationManager />} />
				<Route path="data" element={<IntervalPageV2 display={"table"} />} />
				<Route path="data1" element={<IntervalPage type={0} display={"table"} />} />
				<Route path="data2" element={<IntervalPage type={1} display={"table"} />} />
				<Route path="data1-solar" element={<IntervalPageSolar type={'solar1'} display={"table"} />} />
				<Route path="data2-solar" element={<IntervalPageSolar type={'solar2'} display={"table"} />} />
				<Route path="data-trap" element={<IntervalPageRadarpest type={3} display={"table"} />} />
				<Route path="devices">
					<Route index element={<Navigate to="/dashboard" />} />
					<Route path=":deviceid" element={<DevicePage />} />
				</Route>
				<Route path="devices-manager" element={<DevicesManagerPage />} />
				<Route path="dss">
					<Route index element={<ServiceSelectionPage menu={cropMenu(project) || []} />} />
					<Route path=":crop">
						<Route index element={<ServiceSelectionPage menu={dssMenu(user) || []} />} />
						<Route path="adversities" element={<AdversitiesPage />} />
						<Route path="phenology" element={<PhenologyPage />} />
						<Route path="settings" element={<SettingsAgrismartDss />} />
					</Route>
				</Route>
				<Route path="guide">
					<Route index element={<Navigate to="/404" />} />
					<Route path=":topic" element={<GuidePage />} />
				</Route>
				<Route path="meteoservice" element={<ServiceSelectionPage menu={meteoServiceMenu() || []} />} />
				<Route path="profile" name="Profilo" element={<ProfileContainer />} />
				<Route path="review" element={<ReviewPage />} />
				<Route path="review2" element={<ReviewPageV2 />} />
				<Route path="settings" element={<SettingsPage />} />
				<Route path="statisticsDetails" element={<AveragePage />} />
				<Route path="statisticsDetailsV2" element={<AveragePageV2 />} />
				<Route path="statistics-olivo-cicloconio" element={<AveragePage type={'olivo-cicloconio'}/>} />
				<Route path="statistics-melo-ticchiolatura" element={<AveragePage type={'melo-ticchiolatura'}/>} />
				<Route path="stats-solar" element={<SolarsmartAveragePage />} />
				<Route path="switch-data" element={<SwitchData />} />
				<Route path="trapinst">
					<Route index element={<Navigate to="/404" />} />
					<Route path=":trapId" >
						<Route index element={<Navigate to="/404" />} />
						<Route path="charts" element={<IntervalPageTrapinst display={"charts"} type={'trap'} />} />
						<Route path="data" element={<IntervalPageTrapinst display={"table"} type={3} />} />
					</Route>
				</Route>
				<Route path="users" name="Utenti" element={<UsersContainer />} />

				<Route path="*" element={<Missing />} />
			</Route>
		</Routes>
	);
}
